import { render, staticRenderFns } from "./Achievements.vue?vue&type=template&id=d639a8ac&scoped=true&"
import script from "@/scripts/Achievements/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Achievements/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d639a8ac",
  null
  
)

export default component.exports